import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import bio from '@/components/bio'
import Prayers from '@/components/Prayers'
import piligrim from '@/components/piligrim'
import air from '@/components/air'
import token from '@/components/token'
import Historicsites from '@/components/Historicsites'
import marker from '@/components/marker'
import login from '@/components/Login'
import signup from '@/components/Signup'
import instruction from '@/components/instructions'
import Darshan from '@/components/Darshan'
import Update from '@/components/Update'
import Schedule from '@/components/amartithi-schedule'
import Donations from '@/components/donations'
import Amartithi2021 from '@/components/amartithi-2021.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/bio',
      name: 'bio',
      component: bio
    },
    {
      path: '/Prayers',
      name: 'Prayers',
      component: Prayers
    },
    {
      path: '/air',
      name: 'air',
      component: air
    },
    {
      path: '/piligrim',
      name: 'piligrim',
      component: piligrim
    },
    {
      path: '/token',
      name: 'token',
      component: token
    },
    {
      path: '/Historicsites',
      name: 'Historicsites',
      component: Historicsites
    },
    {
      path: '/marker/:infoText',
      name: 'marker',
      component: marker
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/signup',
      name: 'signup',
      component: signup
    },
    {
      path: '/instruction',
      name: 'instruction',
      component: instruction
    },
    {
      path: '/changeToken',
      name: 'Darshan',
      component: Darshan
    },
    {
      path: '/update',
      name: 'Update',
      component: Update
    },
    {
      path: '/schedule',
      name: 'Schedule',
      component: Schedule
    },
    {
      path: '/donations',
      name: 'Donations',
      component: Donations
    },
    {
      path: '/amartithi-2021-live',
      name: 'Amartithi2021',
      component: Amartithi2021
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js